<div class="db-themes" [ngClass]="{'empty-page': themes && (!themes.length || (themes.length === 1 && themes[0]?.slug === activeTheme?.slug))}">
  <db-ai-builder-demo-banner *ngIf="demoUser" [class]="'with_margins'"
                             [title]="'WordPress Themes'" [features]="features">
  </db-ai-builder-demo-banner>
  <ds-mobile-page-title></ds-mobile-page-title>

  <div class="db-buttons__addThemes" [ngClass]="{'disabled-with-overlay': demoUser}" *ngIf="allThemes && allThemes.length > 1">
    <a class="ds-btn ds-btn-m ds-btn-blue" (click)="onAvailableThemes()"><span>{{'text_addTheme' | dbText | lowerCaseSpecificWords}}</span></a>
  </div>
  <div class="db-themes-container" [ngClass]="{'db-page-with-banner': hasHostingBanner, 'disabled-with-overlay': demoUser}">
    <div class="active-theme" *ngIf="activeTheme">
      <div class="active-theme-header">
        {{'text_activeTheme' | dbText}}
      </div>
      <div class="active-theme-content">
          @if (activeTheme?.slug !== "tenweb-website-builder-theme") {
              <div class="theme-image-wrap" [ngStyle]="{backgroundImage: 'url(' + activeTheme?.logo + ')'}"></div>
          }
        <div class="theme-description">
          <div class="theme-title">{{activeTheme?.title}}</div>
          <div class="theme-version" [innerHTML]="'text_activeThemeVersion' | dbText: { version: activeTheme.version}" *ngIf="!(ongoingActivity$ | async)"></div>
          <div class="theme-update" *ngIf="activeTheme.updateAvailable">
            <div class="db-product-item__theme-information" *ngIf="activeTheme.type === 'theme' && (ongoingActivity$ | async) && (ongoingActivity$ | async).action === ActivityAction.UPDATE">
              <div class="db-product-item__progress-bars"  [ngClass]="{'show': (ongoingActivity$ | async)}">
                <span *ngIf="(ongoingActivity$ | async) && (ongoingActivity$ | async).action === ActivityAction.UPDATE && ((ongoingActivity$ | async).status === ActivityStatus.PENDING || (ongoingActivity$ | async).status === ActivityStatus.RUNNING)" class="color-process">{{'text_themeUpdateProcess' | dbText}}</span>
                <span *ngIf="(ongoingActivity$ | async) && (ongoingActivity$ | async).action === ActivityAction.UPDATE && (ongoingActivity$ | async).status === ActivityStatus.DONE && (ongoingActivity$ | async).status !== ActivityStatus.FAILED" class="color-success">{{'text_themeUpdateSuccess' | dbText}}</span>
                <span *ngIf="(ongoingActivity$ | async) && (ongoingActivity$ | async).status === ActivityStatus.FAILED" class="color-installed">{{'text_installDanger' | dbText}}</span>
                <div class="db-product-item__installing" >
                  <db-progress-bar size="sm" [state]="ongoingActivityStatusClass$ | async" [progressPercent]="(ongoingActivity$ | async).progress"></db-progress-bar>
                </div>
              </div>
            </div>
            <a class="db-button db-button_info" (click)="showChangelog()"><span>{{'text_updatePaidversion' | dbText: { paidVersion: activeTheme.paidVersionInstalled ? activeTheme.currentVersion.paid : activeTheme.currentVersion.free } }}</span></a>
          </div>

        </div>
      </div>
    </div>
    <div class="themes-content">
      <ds-tabs [activeTabId]="filterBy.value" (onActiveTabChange)="onThemesStateChange($event)" class="db-themes__tabs">
        <ds-tab-head [withBorder]="true" tabId="all" [activeTabId]="filterBy.value"><span class="sl-all-themes">{{'text_all-themes' | dbText}}</span></ds-tab-head>
        <!--<ds-tab-head [withBorder]="true" tabId="scheduling" [activeTabId]="filterBy.value"><span>{{'text_scheduling' | dbText}}</span></ds-tab-head>
        <ds-tab-head [withBorder]="true" tabId="schedulingHistory" [activeTabId]="filterBy.value"><span >{{'text_plugins-scheduling-history' | dbText}}</span></ds-tab-head>-->
        <ds-tab-content *ngIf="filterBy.value === 'all'" class="db-themes__tab-content">
          <div class="db-themes__content_list">
            <div class="db-themes__content db-themes__content_list_view">
              <div class="db-themes__items">
                <div *ngIf="themes && (themes.length && !(themes.length === 1 && themes[0].productId && themes[0].productId === activeTheme && activeTheme.productId))" class="db-themes__filters db-filters-bar">
                  <div>
                    <label class="db-themes__select-all-toggle" *ngIf="userPermissions?.canManageContent && !website?.isLocalhost">
                      <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                      <span>{{'text_managerThemesShort' | dbText}}</span>
                    </label>
                  </div>
                  <div [ngClass]="{'db-go-right': website?.isLocalhost}">
                    <div class="search-wrap" >
                      <db-fc-search-input [formControl]="searchTerm" [placeholderTitle]="'text_searchThemesPlaceholder' | dbText"  placeholder="SEARCH"></db-fc-search-input>
                    </div>
                  </div>
                </div>
                <div dbCustomScrollbar class="db-product-items-wrap" *ngIf="filteredThemes && filteredThemes.length">
                  <db-product-item (toggled)="onItemToggled()" [@productItemAnimation]="!updatingProductsList" class="db-product-item-host_view_{{itemsView.value}} db-product-item__{{i}}" [website]="website" [product]="theme" [scope]="themesScope" [userPermissions]="userPermissions" [activeTab]="'allThemes'" (toggled)="onItemToggled()" *ngFor="let theme of filteredThemes; trackBy: productTrackBy; let i = index;"></db-product-item>
                </div>
                <db-empty-search *ngIf="themes && themes.length && !(themes.length === 1 && themes[0].productId && themes[0].productId === activeTheme && activeTheme.productId) && filteredThemes && !filteredThemes.length"></db-empty-search>
                <div class="db-no-items-message" *ngIf="themes && !themes.length">
                  <div class="db-no-item-image-wrap  themes-image">
                    <img class="db-no-item-image" src="assets/images/icons/themes_green.svg" alt=""/>
                  </div>
                  <div class="db-no-item-desc"><span [innerHtml]="'text_notThemes' | dbText"></span></div>
                  <div class="db-buttons__addThemes"><a (click)="onAvailableThemes()" class="db-button db-button_info db-button_lg"><span>{{'text_addTheme' | dbText}}</span></a></div>
                </div>
              </div>
            </div>
            <span *ngIf="userPermissions?.canManageContent && itemsView.value === 'list' && filteredThemes && filteredThemes.length" class="db-themes__actions">
              <a class="ds-btn ds-btn-s ds-btn-green" (click)="applyBulkAction(ActivityAction.ACTIVATE, false)"
                 [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedThemes.length ||
                 selectedThemes.length > 1}"><span>{{'text_activate' | dbText}}</span></a>
              <a class="ds-btn ds-btn-s ds-btn-red" (click)="applyBulkAction(ActivityAction.DEACTIVATE_DELETE, false)"
                 [ngClass]="{'ds-btn-disabled': website?.isLocalhost || !selectedThemes.length}"><span>{{'text_delete' |
                dbText}}</span></a>
              <span *ngIf="!!selectedThemes.length">{{'text_selectedThemesCount' | dbText : {selectedThemesCount: selectedThemes.length} }}</span>
            </span>
          </div>
        </ds-tab-content>

        <ds-tab-content *ngIf="filterBy.value === 'scheduling'">
          <div class="db-themes__schedule-tab" dbCustomScrollbar>
            <div class="db-scheduling-enable-block">
              <div class="db-switch-title">{{ 'text_enableScheduling' | dbText }}</div>
              <label class="db-fc-switch sl-enable-scheduling-switch">
                <input class="db-switch__input" type="checkbox" [checked]="scheduleEnabled" (change)="enableScheduling($event)">
                <span class="db-switch__bg">
                        <span class="db-switch__head"></span>
                      </span>
              </label>
            </div>
            <div class="db-scheduling-wrap" [ngClass]="{'db-disabled': !scheduleEnabled}">
              <div class="db-schedule-main-content">
                <db-schedule *ngIf="scheduleCronExpression" (cronExpressionString)="generateScheduleData($event)" [cron_expression]="scheduleCronExpression" [title]="'Choose themes schedule that suits your website best'"></db-schedule>
              </div>
<!--              <div class="db-schedule-backup-block" *ngIf="!(currentSubscription?.plan?.planPrice === 0 && !!website?.domain_hash)">
                <div class="db-schedule-backup-block-text">
                  <div class="db-schedule-backup-block-text-title">{{'text_pluginsBackupSchedulingTitle' | dbText}}</div>
                  <div class="db-schedule-backup-block-text-desc">{{'text_pluginsBackupSchedulingDesc' | dbText}}</div>
                </div>
                <div class="db-schedule-backup-block-actions">
                  <div class="db-schedule-backup-block-actions-enable" *ngIf="!backupPlugin.active">
                    <a [routerLink]="['../../backup']" >Enable backup service</a><span> to perform safe update</span>
                  </div>
                  <div class="db-schedule-backup-block-actions-enabled" *ngIf="backupPlugin.active">
                    <label class="db-fc-switch sl-enable-scheduling-switch">
                      <input class="db-switch__input" type="checkbox" [checked]="scheduleWithBackupEnabled" (change)="enableSchedulingWithBackup($event)">
                      <span class="db-switch__bg">
                        <span class="db-switch__head"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>-->
              <div class="db-schedule-include-exclude-block">
                <div class="db-schedule-include-exclude-title">{{'text_themesScheduleIncludeExcludeTitle' | dbText}}</div>
                <div class="items-wrap db-panel_flex">
                  <div>
                    <db-product-item-schedule (toggled)="onItemToggledForSchedule()" *ngFor="let product of themesForSchedule; trackBy: productTrackBy; let i = index;" class="db-product-item-host_view_list db-product-item__{{i}}" (actionDone)="reloadContent()" [website]="website" [product]="product" ></db-product-item-schedule>
                  </div>
                  <div class="db-panel__footer">
                    <label>
                  <span class="db-fc-checkbox" [ngClass]="{
    'selected': selectAllForSchedule.value}"><input type="checkbox" [formControl]="selectAllForSchedule" (change)="toggleAllItemsSelectedForSchedule($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
                      <span class="db-products__actions-label">{{'text_includeAll' | dbText}}</span>
                    </label>

                    <div>
                      <span *ngIf="selectedThemesForSchedule.length" class="db-products__actions-label">{{'selectedProductsForSchedule' | dbText : {selectedProductsCount: selectedThemesForSchedule.length} }}</span>
                    </div>
                  </div>


                </div>
              </div>
            </div>
            <div class="button-wrap">
              <a class="ds-btn ds-btn-m ds-btn-blue" (click)="onScheduleSubmit()" [ngClass]="{'db-button_disabled': themesScheduleLoading}">
                <span *ngIf="!themesScheduleLoading">{{ 'text_saveSchedule' | dbText }}</span>
                <db-loading-circular-spinner class="sl-save-scheduling-params-progress" *ngIf="themesScheduleLoading"></db-loading-circular-spinner>
              </a>
            </div>
          </div>
          <db-loading-screen [ngClass]="{'hidden': !themeListUpdateLoading}" [pageBlocker]="true"  [loadingMessage]="'Your themes list are updating'"></db-loading-screen>

        </ds-tab-content>

        <ds-tab-content *ngIf="filterBy.value === 'schedulingHistory'">
          <div class="db-panel db-panel_flex db-theme-schedule-update-history-wrap">
            <div class="db-panel__header db-theme-schedule-update-history-header"  *ngIf="themesUpdateHistory && themesUpdateHistory.length">
              <div class="db-header-wrap db-theme-schedule-update-history-header-wrap">
                <div class="db-theme-schedule-update-history-list-title">
                  <span>{{'text_updateHistoryDate' | dbText}}</span>
                  <a class="db-table-sorting-indicator" *ngIf="themesUpdateHistory.length > 1" (click)="sortTable('date')" [ngClass]="getSortDirectionClass('date')"><i class="db-icon db-icon-arrow-down"></i></a>
                </div>
                <div class="db-theme-schedule-update-history-list-title">
                  <span>{{'text_updateHistoryName' | dbText}}</span>
                  <a class="db-table-sorting-indicator" *ngIf="themesUpdateHistory.length > 1" (click)="sortTable('name')" [ngClass]="getSortDirectionClass('name')"><i class="db-icon db-icon-arrow-down"></i></a>
                </div>
                <div class="db-theme-schedule-update-history-list-title">
                  <span>{{'text_updateHistoryUpdatedVersion' | dbText}}</span>
                </div>
              </div>
            </div>
            <div class="db-panel__body db-theme-update-history-block-body"  *ngIf="themesUpdateHistory || (themesUpdateHistory && themesUpdateHistory.length)" dbCustomScrollbar>
              <div class="db-theme-schedule-update-item" *ngFor="let updateItem of themesUpdateHistory">
                <div class="db-theme-schedule-update-item__date">{{updateItem.date | dbDate : 'dd MMM y, HH:mm:ss'}}</div>
                <div class="db-theme-schedule-update-item__name">{{updateItem.name}}</div>
                <div class="db-theme-schedule-update-item__updatedVersion">{{updateItem.oldVersion}}<span> > </span>{{updateItem.newVersion}}</div>
              </div>
            </div>
            <div *ngIf="themesUpdateHistory && !themesUpdateHistory.length" class="db-theme-schedule-update-history-empty">
              <div class="db-theme-schedule-update-history-empty-title">{{'text_scheduleProductUpdateHistoryEmptyTitle' | dbText}}</div>
              <div class="db-theme-schedule-update-history-empty-desc">{{'text_scheduleProductUpdateHistoryEmptyDesc' | dbText}}</div>
            </div>
          </div>

        </ds-tab-content>

      </ds-tabs>
    </div>
  </div>
</div>
